<h2 mat-dialog-title>{{ "invoiceExplorer.exportDialog.title" | translate: {invoiceCount: data.selectedCount} }}</h2>

<mat-dialog-content fxLayout="column" fxLayoutGap="16px">
    <div class="export-options" fxLayout="column" fxLayoutGap="16px">
        <div
                class="export-option"
                [class.selected]="selectedFormat === 'csv'"
                (click)="export('csv')"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="16px">

            <div class="option-icon csv-icon">
                <mat-icon>description</mat-icon>
            </div>
            <div class="option-content" fxFlex>
                <h3>{{ "invoiceExplorer.exportDialog.csvFile" | translate }}</h3>
                <p>{{ "invoiceExplorer.exportDialog.csvDesc" | translate }}</p>
            </div>
        </div>

        <div
                class="export-option"
                [class.selected]="selectedFormat === 'excel'"
                [class.disabled]="data.selectedCount > maxExport"
                (click)="data.selectedCount > maxExport ? null : export('excel')"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="16px">

            <div class="option-icon excel-icon">
                <mat-icon>grid_on</mat-icon>
            </div>
            <div class="option-content" fxFlex>
                <h3>{{ "invoiceExplorer.exportDialog.excelFile" | translate }}</h3>
                <p>{{ "invoiceExplorer.exportDialog.excelDesc" | translate }}</p>
            </div>
        </div>
    </div>

    <div class="warning-message"
         *ngIf="data.selectedCount > maxExport"
         fxLayout="row"
         fxLayoutAlign="start start"
         fxLayoutGap="12px">
        <mat-icon class="button-icon" color="warn">report_problem</mat-icon>
        <div class="warning-text" fxFlex [innerHTML]="'invoiceExplorer.exportDialog.maxExport' | translate: {maxExport: maxExport}">
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="cancel()">{{ 'global.cancel' | translate }}</button>
</mat-dialog-actions>
